
/*

global

$
jQuery
*/

const pageHeader = (function($) { // eslint-disable-line

	const me = {};

	const variables = {
		$menuTrigger: $('.js-trigger-menu'),
		$hamburger: $('.menu-trigger .hamburger'),
		$pageHeader: $('.page-header'),
		$body: $('body'),
		$menuWrapper: $('.menu-wrapper'),
		$itemsToBlur: $('main, .page-footer'),
		animationDuration: 200,
	};

	let scrollPos;

	const showMobileMenu = (() => {

		scrollPos = $(window).scrollTop();

		variables.$pageHeader.addClass('menu-visible');
		variables.$hamburger.addClass('is-active');
		variables.$itemsToBlur.addClass('is-blurred');

		setTimeout(() => {

			variables.$body.addClass('has-mobile-nav');
			variables.$body.css('transform', 'translateY(-' + scrollPos + 'px)');
			variables.$pageHeader.css('transform', 'translateY(' + scrollPos + 'px)');

		}, variables.animationDuration);

	});

	const hideMobileMenu = (() => {

		variables.$pageHeader.removeClass('menu-visible');
		variables.$hamburger.removeClass('is-active');
		variables.$itemsToBlur.removeClass('is-blurred');
		variables.$body.removeClass('has-mobile-nav');
		variables.$body.css('transform', '');
		variables.$pageHeader.css('transform', '');

		$(window).scrollTop(scrollPos);

	});

	const resetMobileMenu = (() => {

		if (window.innerWidth > 768) {

			if (variables.$body.hasClass('has-mobile-nav')) {

				hideMobileMenu();

			}

		}

	});

	const handleMobileNavigation = (() => {

		variables.$menuTrigger.on('click', (e) => {

			e.preventDefault();

			if (window.innerWidth < 768 && !variables.$pageHeader.hasClass('menu-visible')) {

				showMobileMenu();

			} else {

				hideMobileMenu();

			}

		});

	});

	me.init = function() {

		handleMobileNavigation();

		$(window).on('resize', () => {

			resetMobileMenu();

		});

	};

	return me;

}(jQuery));

export { pageHeader };
